import { render, staticRenderFns } from "./ErrorViewer.vue?vue&type=template&id=396796b4&"
import script from "./ErrorViewer.vue?vue&type=script&lang=ts&"
export * from "./ErrorViewer.vue?vue&type=script&lang=ts&"
import style0 from "./ErrorViewer.vue?vue&type=style&index=0&id=396796b4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports